import { Service, inject } from '@angular/core';

import { Observable, switchMap, map, catchError, throwError, take } from 'rxjs';

import { ApolloClientService } from 'src/app/services/apollo-client.service';
import { GET_ENVIRONMENTS_BY_FUNCTIONAL_GROUP } from 'src/app/graphql/queries/environment.queries';
import { GraphQLAnalyzerEnvironmentOutput } from 'src/app/graphql/models/output/analyzer-environment.output.model';

/**
 * Service for fetching analyzer environments via GraphQL.
 */
@Service()
export class EnvironmentApiService {
	private apolloClientService = inject(ApolloClientService);

	/**
	 * Fetches environments for a specific functional group.
	 *
	 * @param functionalGroupUid The functional group UID to fetch environments for (can be empty string for all)
	 * @returns Observable of environment strings
	 * @throws Error if the query fails or returns invalid data
	 */
	public getEnvironmentsByFunctionalGroup$(functionalGroupUid: string): Observable<string[]> {
		return this.apolloClientService.apolloClient$.pipe(
			take(1),
			switchMap(client =>
				client.query<{ analyzerGetEnvironmentsByFunctionalGroupUid: GraphQLAnalyzerEnvironmentOutput }>({
					query: GET_ENVIRONMENTS_BY_FUNCTIONAL_GROUP,
					variables: {
						functionalGroupUid: functionalGroupUid,
					},
					fetchPolicy: 'network-only',
				}),
			),
			map(result => {
				if (!result.data?.analyzerGetEnvironmentsByFunctionalGroupUid?.analyzerEnvironments) {
					return [];
				}
				return result.data.analyzerGetEnvironmentsByFunctionalGroupUid.analyzerEnvironments;
			}),
			catchError((error: any) => {
				console.error(`Failed to fetch environments for ${functionalGroupUid}:`, error);
				return throwError(() => error);
			}),
		);
	}
}
